/*
 * Loads third-party tracking scripts only after the visitor has consented.
 * Consent comes from the Shopify Customer Privacy API, which Consentmo updates.
 * Scripts that would otherwise load without consent must not be embedded directly
 * in the theme or as app embeds — register them here instead.
 */
const ConsentScripts = (function ConsentScriptsModule() {
   const CLARITY_PROJECT_ID = "wlsyak7vrj";
   const LINKSTER_SRC = "https://trck.linkster.co/trck/etms/eatms.js?campaign_id=549";

   const loaded = new Set();

   const injectScript = (src) => {
      const script = document.createElement("script");
      script.src = src;
      script.async = true;
      document.head.appendChild(script);
   };

   const loadClarity = () => {
      window.clarity =
         window.clarity ??
         function clarityQueue(...args) {
            window.clarity.q = [...(window.clarity.q ?? []), args];
         };
      injectScript(`https://www.clarity.ms/tag/${CLARITY_PROJECT_ID}`);
      window.clarity("consentv2", { ad_Storage: "denied", analytics_Storage: "granted" });
   };

   const loadLinkster = () => {
      injectScript(LINKSTER_SRC);
   };

   const loaders = [
      { key: "clarity", allowed: ({ analytics }) => analytics, load: loadClarity },
      { key: "linkster", allowed: ({ marketing }) => marketing, load: loadLinkster },
   ];

   const apply = (consent) => {
      loaders
         .filter(({ key, allowed }) => !loaded.has(key) && allowed(consent))
         .forEach(({ key, load }) => {
            loaded.add(key);
            load();
         });
   };

   const readConsent = () => {
      const privacy = window.Shopify?.customerPrivacy;
      return {
         analytics: privacy?.analyticsProcessingAllowed?.() ?? false,
         marketing: privacy?.marketingAllowed?.() ?? false,
      };
   };

   const handleConsentCollected = (event) => {
      const { analyticsAllowed, marketingAllowed } = event.detail ?? {};
      apply({ analytics: analyticsAllowed === true, marketing: marketingAllowed === true });
   };

   return {
      init: function init() {
         document.addEventListener("visitorConsentCollected", handleConsentCollected);

         if (!window.Shopify?.loadFeatures) return;
         window.Shopify.loadFeatures(
            [{ name: "consent-tracking-api", version: "0.1" }],
            (error) => {
               if (error) return;
               apply(readConsent());
            }
         );
      },
   };
})();

document.addEventListener("DOMContentLoaded", ConsentScripts.init);
